import { render, staticRenderFns } from "./InnerComponent.vue?vue&type=template&id=4ce7faa8&scoped=true"
import script from "./InnerComponent.vue?vue&type=script&lang=js"
export * from "./InnerComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ce7faa8",
  null
  
)

export default component.exports